import { render, staticRenderFns } from "./DatasetTaskList.vue?vue&type=template&id=f10dd746&scoped=true&"
import script from "./DatasetTaskList.vue?vue&type=script&lang=js&"
export * from "./DatasetTaskList.vue?vue&type=script&lang=js&"
import style0 from "./DatasetTaskList.vue?vue&type=style&index=0&id=f10dd746&prod&scoped=true&lang=css&"
import style1 from "./DatasetTaskList.vue?vue&type=style&index=1&id=f10dd746&prod&lang=scss&scoped=true&"
import style2 from "./DatasetTaskList.vue?vue&type=style&index=2&id=f10dd746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10dd746",
  null
  
)

export default component.exports